<template>
    <el-main v-loading="loading">
        <el-space wrap fill alignment="flex-start" direction="horizontal" :fill-ratio="screenWidth <= 800 ? 100 : 20 "
            style="width: 100%" v-show="!viewMode">
            <el-card style="width: 100px;min-height:150px;" shadow="hover">
                <el-descriptions title="「操作栏」" :column="1" size="small" border>
                    <template #extra>
                        <el-button v-if="counterpoise_add" icon="CirclePlusFilled" text type="warning"
                            @click="addv()">添加</el-button>
                        <el-switch v-model="viewMode" class="ml-2" inline-prompt
                            style="--el-switch-on-color: #13ce66; --el-switch-off-color: #00aaff" active-text="卡片模式"
                            inactive-text="列表模式" @click="setViewMode" v-show="screenWidth <= 800 ? false : true" />
                    </template>
                    <el-descriptions-item label-width='42'>
                        <template #label>搜索</template>
                        <el-input size="small" v-model="lookup.search.name" placeholder="搜索链接名称" @change="namecakfu()"
                            @blur="namecak = true" clearable />
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template #label>标签</template>
                        <el-checkbox-group v-model="lookup.search.tag" size="small" @change="namecakfu()">
                            <el-checkbox-button label="网站" value="网站" />
                            <el-checkbox-button label="手册" value="手册" />
                            <el-checkbox-button label="制度" value="制度" />
                            <el-checkbox-button label="资料" value="资料" />
                        </el-checkbox-group>
                    </el-descriptions-item>
                </el-descriptions>
                <el-pagination :pager-count='5' size="small" v-model:current-page="lookup.currentPage" background
                    v-model:page-size="lookup.pageSize" hide-on-single-page layout="prev, pager, next, jumper"
                    :total="lookup.total" @size-change="handleCurrentChange" @current-change="handleCurrentChange" />
            </el-card>
            <el-card v-for="(item, index) in fileList" :key="index" style="width: 100px" shadow="hover">
                <el-descriptions :title="item.name" :column="1" size="small" border label-width='42'>
                    <template #extra>
                        <el-button v-if="counterpoise_add" text type="primary" size="small" icon="Edit"
                            @click="tabClick(item)" />
                    </template>
                    <el-descriptions-item>
                        <template #label>描述</template>
                        {{item.remarks}}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template #label>标签</template>
                        {{item.tag}}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template #label>地址</template>
                        <el-link icon="Paperclip" type="primary" :href="item.url" target="_blank">点击查看</el-link>
                    </el-descriptions-item>
                </el-descriptions>
            </el-card>
        </el-space>
        <el-card shadow="never" class="box-card-b" :height="innerHeight <= 400 ? 400 : innerHeight- 178"
            v-show="viewMode">
            <el-table :data="fileList" style="width: 100%" :height="innerHeight <= 400 ? 400 : innerHeight - 132">
                <el-table-column prop="name" label="链接名称" show-overflow-tooltip>
                    <template #header>
                        <el-button icon="Search" type="" text @click="namecak = false" v-if="namecak">链接名称<span
                                v-if="lookup.search.name">：{{lookup.search.name}}</span></el-button>
                        <el-input v-model="lookup.search.name" placeholder="搜索链接名称" v-else @change="namecakfu()"
                            @blur="namecak = true" clearable />
                    </template>
                </el-table-column>
                <el-table-column prop="remarks" label="链接描述" show-overflow-tooltip />
                <el-table-column prop="tag" label="链接标签" show-overflow-tooltip width="300">
                    <template #header>
                        <el-button type="" text>标签：
                            <el-checkbox-group v-model="lookup.search.tag" size="small" @change="namecakfu()">
                                <el-checkbox-button label="网站" value="网站" />
                                <el-checkbox-button label="手册" value="手册" />
                                <el-checkbox-button label="制度" value="制度" />
                                <el-checkbox-button label="资料" value="资料" />
                            </el-checkbox-group>
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="url" label="点击查看" show-overflow-tooltip>
                    <template #header>
                        点击查看
                        <el-switch v-model="viewMode" class="ml-2" inline-prompt
                            style="--el-switch-on-color: #13ce66; --el-switch-off-color: #00aaff" active-text="卡片模式"
                            inactive-text="列表模式" @click="setViewMode" />
                    </template>
                    <template #default="scope">
                        <el-link icon="Paperclip" type="primary" :href="scope.row.url" target="_blank">{{scope.row.url}}
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column label="操作" v-if="counterpoise_add">
                    <template #header>
                        <el-button icon="CirclePlusFilled" text type="warning" @click="addv">操作/添加</el-button>
                    </template>
                    <template #default="scope">
                        <el-button text type="primary" size="small" @click="tabClick(scope.row)">编辑</el-button>
                        <el-button text type="danger" size="small" disabled>删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-footer height='40'>
                <el-pagination v-model:current-page="lookup.currentPage" background v-model:page-size="lookup.pageSize"
                    hide-on-single-page layout="prev, pager, next, jumper " :total="lookup.total"
                    @size-change="handleCurrentChange" @current-change="handleCurrentChange" />
            </el-footer>
        </el-card>
    </el-main>

    <CatChange :changedits='edit' @updatas='updatas' @deletes='deletes' @cancels="edit = false" v-model:changeForms='form'
        :changeHeads='tableHead' />
    <CatAdd :changedits='addedit' @updatas='updatas' @deletes='deletes' @cancels="addedit = false" v-model:changeForms='form'
        :changeHeads='tableHead' />
</template>

<script>
    // 知识库页面
    import CatAdd from '@/components/CatAdd.vue'
    import CatChange from '@/components/CatChange.vue'
    import axios from "@/utils/request";
    import {
        ElMessage
    } from 'element-plus'
    import {
        mapState
    } from 'vuex'
    export default {
        name: 'Repository',
        components: {
            CatAdd,
            CatChange,
        },
        computed: {
            // Vue计算属性
            ...mapState(['innerHeight', 'screenWidth']),
        },
        mounted() {
            const viewMode = window.localStorage.getItem('viewMode')
            if (viewMode !== null) {
                this.viewMode = viewMode == 'true' ? true : false
            }
            this.handleCurrentChange()
        },
        created() {

        },
        data() {
            return {
                namecak: true,
                viewMode: false,
                lookup: {
                    tabname: '知识库表',
                    modifyData: false, //修改指令
                    search: {},
                    export: false,
                    currentPage: 1, //当前所在分页页数
                    pageSize: 19, //一页显示多少数据
                    total: 20, //总共有多少数据
                    data: {}
                },
                tableHead: [],
                loading: false,
                fileList: [],
                edit: false,
                disabled: false, //是否禁用刷新
                addedit: false,
                form: {},
                counterpoise_add: 0,
                counterpoise_edit: 0,
            }
        },
        methods: {
            setViewMode() {
                window.localStorage.setItem('viewMode', this.viewMode)
            },
            handleCurrentChange() {
                this.loading = true
                axios({
                    method: "post",
                    url: 'getdataother',
                    data: this.lookup,
                }).then(res => {
                    this.fileList = res.data //数据本身
                    this.lookup.total = res.total
                    this.counterpoise_add = res.tableHead.add //添加权限
                    this.tableHead = res.tableHead.tableHead //数据表头
                    this.loading = false
                })
            },
            namecakfu() {
                this.namecak = true
                this.handleCurrentChange()
            },
            deletes(v) {
                this.form = v
                this.edit = false
                this.addedit = false
                if (this.form.index != undefined) {
                    this.fileList.splice(this.form.index, 1)
                }
            },
            addv() { //增加
                this.addedit = false
                this.form = {}
                this.addedit = true
            },
            tabClick(row) {
                //筛选数据
                this.edit = true
                this.form = row
            },
            updatas() {
                this.edit = false
                this.lookup.data[0] = this.form
                this.loading = true
                this.addedit = false
                axios({
                    method: "post",
                    url: 'updata',
                    data: this.lookup,
                }).then(res => {
                    ElMessage({
                        type: "success",
                        message: `添加${res.add}行数据，更新${res.update}行数据`,
                    })
                    if (res.addate) {
                        res.addate.map((vs) => {
                            this.fileList.push(vs)
                        })
                    }
                    this.loading = false
                })
            }
        }
    }
</script>

<style scoped>
    .el-main {
        padding: 0 !important;
    }
</style>